<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <!-- Therapy-specific fields for Ambler Gait Therapy -->
            <v-col sm="6" v-if="form.position_id == 3">
              <v-text-field
                v-model="form.height"
                outlined
                label="Height (cm)"
                prepend-inner-icon="mdi-human-male-height"
                type="number"
                step="0.01"
                :error-messages="errors.height"
              ></v-text-field>
            </v-col>
            <v-col sm="6" v-if="form.position_id == 3">
              <v-text-field
                v-model="form.weight"
                outlined
                label="Weight (kg)"
                prepend-inner-icon="mdi-scale"
                type="number"
                step="0.01"
                :error-messages="errors.weight"
              ></v-text-field>
            </v-col>
            <v-col sm="12" v-if="form.position_id == 3">
              <v-textarea
                v-model="form.diagnosis"
                outlined
                label="Medical Diagnosis"
                prepend-inner-icon="mdi-clipboard-text"
                rows="3"
                :error-messages="errors.diagnosis"
              ></v-textarea>
            </v-col>
            <v-col sm="12" v-if="form.position_id == 3">
              <v-textarea
                v-model="form.therapy_goals"
                outlined
                label="Therapy Goals & Objectives"
                prepend-inner-icon="mdi-target"
                rows="3"
                :error-messages="errors.therapy_goals"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save User
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        soft_password: "123456",
      },
      positionItems: [],
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"];
    },
  },
  mounted() {
    this.form.company_id = this.company.id;
    this.form.role_id = "3";
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get(`masters?context=user`);
        const masters = response.data;

        console.log("Masters response:", masters);
        console.log("Logged in user:", this.user);
        console.log("User position:", this.user?.position);

        // get logged in user position from localStorage / Vuex / API
        const loggedInUser = this.user;
        const userPosition = loggedInUser?.position?.name; // adjusted with optional chaining

        console.log("User position name:", userPosition);

        // Clear previous items
        this.positionItems = [];

        // Filter positions
        if (masters.positions && Array.isArray(masters.positions)) {
          masters.positions.forEach((position) => {
            console.log("Processing position:", position);

            if (userPosition === "HOSPITAL ADMIN") {
              // Show only THERAPIST in dropdown
              if (position.name === "THERAPIST") {
                this.positionItems.push({
                  id: position.id,
                  text: position.name,
                  value: position.id,
                });
              }
            } else {
              // Other users see all positions
              this.positionItems.push({
                id: position.id,
                text: position.name,
                value: position.id,
              });
            }
          });
        } else {
          console.error("masters.positions is not an array or is undefined");
        }
      } catch (error) {
        console.error("Error in getMasters:", error);
        // redirect to Home Page
        //window.location.href = "/auth/login";
      }
      console.log("Final positionItems:", this.positionItems);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/users", this.form);
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        this.$router.push("/users");
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>
